import { AD_IMG } from "@/data/site";

const AdBanner = () => {
  return (
    <section
      data-testid="ad-banner"
      className="relative bg-black text-white overflow-hidden grain"
    >
      <div className="grid md:grid-cols-2">
        <div className="relative min-h-[320px] md:min-h-[560px] overflow-hidden">
          <img
            src={AD_IMG}
            alt="Advertise in Texas Journal"
            className="absolute inset-0 h-full w-full object-cover opacity-80"
          />
        </div>
        <div className="flex flex-col justify-center px-6 md:px-16 py-16 md:py-0">
          <span className="font-accent uppercase text-xs tracking-[0.3em] text-white/50">
            Advertise / This Space
          </span>
          <h2 className="font-serif-display text-4xl md:text-6xl leading-[0.95] tracking-tight mt-4">
            Your brand,
            <br />
            <span className="italic font-light">in print &amp; pixels.</span>
          </h2>
          <p className="mt-6 max-w-md font-light text-white/70 leading-relaxed">
            Premium full-page placements in the magazine and featured positions
            online. Reach a style-led audience across every major Texas city.
          </p>
          <a
            href="#advertise"
            data-testid="ad-banner-cta"
            className="mt-8 inline-flex w-fit items-center font-accent uppercase text-xs tracking-[0.25em] border border-white px-7 py-3.5 hover:bg-white hover:text-black transition-colors duration-300"
          >
            Reserve a Placement
          </a>
        </div>
      </div>
    </section>
  );
};

export default AdBanner;
